"use client";

import React from "react";
import { Badge } from "@/components/ui/badge";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function NoticeHero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="38883" id="page-introduction" className="relative flex min-h-[80vh] w-full flex-col items-center justify-center overflow-hidden bg-[#050a11] px-4 py-24 text-[#f8fafc]">
      {}
      <div className="pointer-events-none absolute inset-0 flex items-center justify-center overflow-hidden">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1604101/img/academy_logo_watermark.png" alt="" className="h-[120%] w-auto opacity-10 grayscale invert brightness-150 blur-[2px]" />
      </div>

      {}
      <div ref={ref} className={cn("relative z-10 flex max-w-5xl flex-col items-center text-center transition-all duration-1000 ease-out", isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0")}>
        {}
        <Badge variant="default" className="mb-8 border-none bg-primary/20 px-4 py-1.5 text-sm font-semibold tracking-widest text-primary hover:bg-primary/30 shadow-lg shadow-primary/10">
          Legal Framework
        </Badge>

        {}
        <h1 className="mb-6 font-sans text-5xl font-bold leading-tight tracking-tight text-[#f8fafc] sm:text-6xl md:text-7xl lg:text-7xl drop-shadow-[0_0_15px_rgba(0,255,255,0.4)]">
          Terms of Service & <br className="hidden md:block" />
          Usage Guidelines
        </h1>

        {}
        <p className="mb-12 max-w-2xl font-sans text-lg font-normal leading-relaxed text-[#cbd5e1] sm:text-xl md:text-[1.125rem]">
          Our commitment to transparency and security starts with a clear understanding 
          of our operational standards and user responsibilities within our network.
        </p>

        {}
        <div className="h-[1px] w-48 bg-gradient-to-r from-transparent via-primary to-transparent shadow-[0_0_12px_rgba(0,255,255,0.6)]" />
      </div>
    </section>;
}